export interface NavItem {
  path: string;
  label: string;
  icon: string;
}

export const NAV_ITEMS: NavItem[] = [
  { path: "/", label: "Dashboard", icon: "ri-dashboard-3-line" },
  { path: "/gastos", label: "Gastos", icon: "ri-wallet-3-line" },
  { path: "/recibos", label: "Recibos", icon: "ri-receipt-line" },
  { path: "/estadisticas", label: "Estadísticas", icon: "ri-bar-chart-2-line" },
  { path: "/categorias", label: "Categorías", icon: "ri-price-tag-3-line" },
  { path: "/configuracion", label: "Configuración", icon: "ri-settings-3-line" },
];

export const TITLES: Record<string, string> = {
  "/": "Dashboard",
  "/gastos": "Gastos",
  "/gastos/nuevo": "Nuevo gasto",
  "/recibos": "Recibos",
  "/estadisticas": "Estadísticas",
  "/categorias": "Categorías",
  "/configuracion": "Configuración",
};

export function titleForPath(pathname: string): string {
  if (pathname.startsWith("/gastos/nuevo")) return "Nuevo gasto";
  if (pathname.startsWith("/gastos/")) return "Detalle del gasto";
  return TITLES[pathname] ?? "Dashboard";
}